import axios from 'axios';

const failure = (error, fallback) => ({
  success: false,
  message: error?.response?.data?.message || (typeof error?.response?.data === 'string' && error.response.data) || fallback
});

const acceptInvitation = (token) => {
  return axios
    .get(`${process.env.REACT_APP_API_SERVER_HOST}/password/accept-invitation`, {
      params: { token },
      headers: { Accept: 'application/json' }
    })
    .then(() => ({ success: true }))
    .catch((error) => ({
      success: false,
      message: error?.response?.data?.message || error?.response?.data || 'This invitation link is invalid or has expired.'
    }));
};

const verifyGroupInvitation = (token) => {
  return axios
    .get(`${process.env.REACT_APP_API_SERVER_HOST}/corporateGroup/invitation`, {
      params: { token },
      headers: { Accept: 'application/json' }
    })
    .then((response) => response.data)
    .catch((error) => failure(error, 'This invitation link is invalid or has expired.'));
};

const acceptGroupInvitation = (token, password) => {
  return axios
    .post(`${process.env.REACT_APP_API_SERVER_HOST}/corporateGroup/invitation/accept`, { token, password })
    .then((response) => response.data)
    .catch((error) => failure(error, 'Unable to accept the invitation. Please try again.'));
};

export const invitationService = {
  acceptInvitation,
  verifyGroupInvitation,
  acceptGroupInvitation
};
